
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6qld8", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $0134fe72f7983f2b$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $0134fe72f7983f2b$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "registerVersion", function () { return $0134fe72f7983f2b$export$d29d5299a7137abc; });
$parcel$export(module.exports, "initializeApp", function () { return $0134fe72f7983f2b$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $0134fe72f7983f2b$export$f9962582c9e66d99; });

var $cFrOI = parcelRequire("cFrOI");

var $9plvI = parcelRequire("9plvI");

var $cGDM2 = parcelRequire("cGDM2");

var $azjoc = parcelRequire("azjoc");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0134fe72f7983f2b$var$PlatformLoggerServiceImpl {
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($0134fe72f7983f2b$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
    constructor(container){
        this.container = container;
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $0134fe72f7983f2b$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $0134fe72f7983f2b$var$name$p = "@firebase/app";
const $0134fe72f7983f2b$var$version$1 = "0.10.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0134fe72f7983f2b$var$logger = new (0, $9plvI.Logger)("@firebase/app");
const $0134fe72f7983f2b$var$name$o = "@firebase/app-compat";
const $0134fe72f7983f2b$var$name$n = "@firebase/analytics-compat";
const $0134fe72f7983f2b$var$name$m = "@firebase/analytics";
const $0134fe72f7983f2b$var$name$l = "@firebase/app-check-compat";
const $0134fe72f7983f2b$var$name$k = "@firebase/app-check";
const $0134fe72f7983f2b$var$name$j = "@firebase/auth";
const $0134fe72f7983f2b$var$name$i = "@firebase/auth-compat";
const $0134fe72f7983f2b$var$name$h = "@firebase/database";
const $0134fe72f7983f2b$var$name$g = "@firebase/database-compat";
const $0134fe72f7983f2b$var$name$f = "@firebase/functions";
const $0134fe72f7983f2b$var$name$e = "@firebase/functions-compat";
const $0134fe72f7983f2b$var$name$d = "@firebase/installations";
const $0134fe72f7983f2b$var$name$c = "@firebase/installations-compat";
const $0134fe72f7983f2b$var$name$b = "@firebase/messaging";
const $0134fe72f7983f2b$var$name$a = "@firebase/messaging-compat";
const $0134fe72f7983f2b$var$name$9 = "@firebase/performance";
const $0134fe72f7983f2b$var$name$8 = "@firebase/performance-compat";
const $0134fe72f7983f2b$var$name$7 = "@firebase/remote-config";
const $0134fe72f7983f2b$var$name$6 = "@firebase/remote-config-compat";
const $0134fe72f7983f2b$var$name$5 = "@firebase/storage";
const $0134fe72f7983f2b$var$name$4 = "@firebase/storage-compat";
const $0134fe72f7983f2b$var$name$3 = "@firebase/firestore";
const $0134fe72f7983f2b$var$name$2 = "@firebase/vertexai-preview";
const $0134fe72f7983f2b$var$name$1 = "@firebase/firestore-compat";
const $0134fe72f7983f2b$var$name = "firebase";
const $0134fe72f7983f2b$var$version = "10.12.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $0134fe72f7983f2b$export$9f30fa0c10967f7f = "[DEFAULT]";
const $0134fe72f7983f2b$var$PLATFORM_LOG_STRING = {
    [$0134fe72f7983f2b$var$name$p]: "fire-core",
    [$0134fe72f7983f2b$var$name$o]: "fire-core-compat",
    [$0134fe72f7983f2b$var$name$m]: "fire-analytics",
    [$0134fe72f7983f2b$var$name$n]: "fire-analytics-compat",
    [$0134fe72f7983f2b$var$name$k]: "fire-app-check",
    [$0134fe72f7983f2b$var$name$l]: "fire-app-check-compat",
    [$0134fe72f7983f2b$var$name$j]: "fire-auth",
    [$0134fe72f7983f2b$var$name$i]: "fire-auth-compat",
    [$0134fe72f7983f2b$var$name$h]: "fire-rtdb",
    [$0134fe72f7983f2b$var$name$g]: "fire-rtdb-compat",
    [$0134fe72f7983f2b$var$name$f]: "fire-fn",
    [$0134fe72f7983f2b$var$name$e]: "fire-fn-compat",
    [$0134fe72f7983f2b$var$name$d]: "fire-iid",
    [$0134fe72f7983f2b$var$name$c]: "fire-iid-compat",
    [$0134fe72f7983f2b$var$name$b]: "fire-fcm",
    [$0134fe72f7983f2b$var$name$a]: "fire-fcm-compat",
    [$0134fe72f7983f2b$var$name$9]: "fire-perf",
    [$0134fe72f7983f2b$var$name$8]: "fire-perf-compat",
    [$0134fe72f7983f2b$var$name$7]: "fire-rc",
    [$0134fe72f7983f2b$var$name$6]: "fire-rc-compat",
    [$0134fe72f7983f2b$var$name$5]: "fire-gcs",
    [$0134fe72f7983f2b$var$name$4]: "fire-gcs-compat",
    [$0134fe72f7983f2b$var$name$3]: "fire-fst",
    [$0134fe72f7983f2b$var$name$1]: "fire-fst-compat",
    [$0134fe72f7983f2b$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$0134fe72f7983f2b$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $0134fe72f7983f2b$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $0134fe72f7983f2b$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0134fe72f7983f2b$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $0134fe72f7983f2b$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $0134fe72f7983f2b$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $0134fe72f7983f2b$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $0134fe72f7983f2b$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($0134fe72f7983f2b$export$9566bce3835c0f28.has(componentName)) {
        $0134fe72f7983f2b$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $0134fe72f7983f2b$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $0134fe72f7983f2b$export$b4e3c36c855b14b5.values())$0134fe72f7983f2b$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $0134fe72f7983f2b$export$fb03ad8d3d5c5f76.values())$0134fe72f7983f2b$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $0134fe72f7983f2b$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $0134fe72f7983f2b$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $0134fe72f7983f2b$export$9f30fa0c10967f7f) {
    $0134fe72f7983f2b$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $0134fe72f7983f2b$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $0134fe72f7983f2b$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $0134fe72f7983f2b$export$3685d89b9c3cdfaf() {
    $0134fe72f7983f2b$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0134fe72f7983f2b$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $0134fe72f7983f2b$var$ERROR_FACTORY = new (0, $cGDM2.ErrorFactory)("app", "Firebase", $0134fe72f7983f2b$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0134fe72f7983f2b$var$FirebaseAppImpl {
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $cFrOI.Component)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0134fe72f7983f2b$var$FirebaseServerAppImpl extends $0134fe72f7983f2b$var$FirebaseAppImpl {
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $0134fe72f7983f2b$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegisry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $0134fe72f7983f2b$export$d29d5299a7137abc($0134fe72f7983f2b$var$name$p, $0134fe72f7983f2b$var$version$1, "serverapp");
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $0134fe72f7983f2b$export$31499a9cd224b78c = $0134fe72f7983f2b$var$version;
function $0134fe72f7983f2b$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $0134fe72f7983f2b$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $cGDM2.getDefaultAppConfig)());
    if (!options) throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $0134fe72f7983f2b$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $cGDM2.deepEqual)(options, existingApp.options) && (0, $cGDM2.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $cFrOI.ComponentContainer)(name);
    for (const component of $0134fe72f7983f2b$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $0134fe72f7983f2b$var$FirebaseAppImpl(options, config, container);
    $0134fe72f7983f2b$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $0134fe72f7983f2b$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $cGDM2.isBrowser)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($0134fe72f7983f2b$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $0134fe72f7983f2b$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $cFrOI.ComponentContainer)(nameString);
    for (const component of $0134fe72f7983f2b$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $0134fe72f7983f2b$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $0134fe72f7983f2b$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $0134fe72f7983f2b$export$f9962582c9e66d99(name = $0134fe72f7983f2b$export$9f30fa0c10967f7f) {
    const app = $0134fe72f7983f2b$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $0134fe72f7983f2b$export$9f30fa0c10967f7f && (0, $cGDM2.getDefaultAppConfig)()) return $0134fe72f7983f2b$export$c55cfd413944906d();
    if (!app) throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $0134fe72f7983f2b$export$68ddedf7d44b3bdf() {
    return Array.from($0134fe72f7983f2b$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $0134fe72f7983f2b$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($0134fe72f7983f2b$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $0134fe72f7983f2b$export$b4e3c36c855b14b5.delete(name);
    } else if ($0134fe72f7983f2b$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $0134fe72f7983f2b$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $0134fe72f7983f2b$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $0134fe72f7983f2b$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $0134fe72f7983f2b$var$logger.warn(warning.join(" "));
        return;
    }
    $0134fe72f7983f2b$export$c930050e7bb63965(new (0, $cFrOI.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $0134fe72f7983f2b$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $9plvI.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $0134fe72f7983f2b$export$c622e99c0ce7b1c9(logLevel) {
    (0, $9plvI.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0134fe72f7983f2b$var$DB_NAME = "firebase-heartbeat-database";
const $0134fe72f7983f2b$var$DB_VERSION = 1;
const $0134fe72f7983f2b$var$STORE_NAME = "firebase-heartbeat-store";
let $0134fe72f7983f2b$var$dbPromise = null;
function $0134fe72f7983f2b$var$getDbPromise() {
    if (!$0134fe72f7983f2b$var$dbPromise) $0134fe72f7983f2b$var$dbPromise = (0, $azjoc.openDB)($0134fe72f7983f2b$var$DB_NAME, $0134fe72f7983f2b$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($0134fe72f7983f2b$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $0134fe72f7983f2b$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $0134fe72f7983f2b$var$dbPromise;
}
async function $0134fe72f7983f2b$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $0134fe72f7983f2b$var$getDbPromise();
        const tx = db.transaction($0134fe72f7983f2b$var$STORE_NAME);
        const result = await tx.objectStore($0134fe72f7983f2b$var$STORE_NAME).get($0134fe72f7983f2b$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $cGDM2.FirebaseError)) $0134fe72f7983f2b$var$logger.warn(e.message);
        else {
            const idbGetError = $0134fe72f7983f2b$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $0134fe72f7983f2b$var$logger.warn(idbGetError.message);
        }
    }
}
async function $0134fe72f7983f2b$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $0134fe72f7983f2b$var$getDbPromise();
        const tx = db.transaction($0134fe72f7983f2b$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($0134fe72f7983f2b$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $0134fe72f7983f2b$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $cGDM2.FirebaseError)) $0134fe72f7983f2b$var$logger.warn(e.message);
        else {
            const idbGetError = $0134fe72f7983f2b$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $0134fe72f7983f2b$var$logger.warn(idbGetError.message);
        }
    }
}
function $0134fe72f7983f2b$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0134fe72f7983f2b$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $0134fe72f7983f2b$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $0134fe72f7983f2b$var$HeartbeatServiceImpl {
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $0134fe72f7983f2b$var$getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $0134fe72f7983f2b$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $0134fe72f7983f2b$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $0134fe72f7983f2b$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $cGDM2.base64urlEncodeWithoutPadding)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $0134fe72f7983f2b$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
}
function $0134fe72f7983f2b$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $0134fe72f7983f2b$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $0134fe72f7983f2b$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($0134fe72f7983f2b$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($0134fe72f7983f2b$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $0134fe72f7983f2b$var$HeartbeatStorageImpl {
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $cGDM2.isIndexedDBAvailable)()) return false;
        else return (0, $cGDM2.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $0134fe72f7983f2b$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0134fe72f7983f2b$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0134fe72f7983f2b$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $0134fe72f7983f2b$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $cGDM2.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0134fe72f7983f2b$var$registerCoreComponents(variant) {
    $0134fe72f7983f2b$export$c930050e7bb63965(new (0, $cFrOI.Component)("platform-logger", (container)=>new $0134fe72f7983f2b$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $0134fe72f7983f2b$export$c930050e7bb63965(new (0, $cFrOI.Component)("heartbeat", (container)=>new $0134fe72f7983f2b$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $0134fe72f7983f2b$export$d29d5299a7137abc($0134fe72f7983f2b$var$name$p, $0134fe72f7983f2b$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $0134fe72f7983f2b$export$d29d5299a7137abc($0134fe72f7983f2b$var$name$p, $0134fe72f7983f2b$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $0134fe72f7983f2b$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $0134fe72f7983f2b$var$registerCoreComponents("");

});
parcelRegister("cFrOI", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $026145bf043df8d8$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $026145bf043df8d8$export$436a80eea5d5c0c5; });

var $cGDM2 = parcelRequire("cGDM2");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $026145bf043df8d8$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $026145bf043df8d8$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $026145bf043df8d8$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $cGDM2.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($026145bf043df8d8$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $026145bf043df8d8$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $026145bf043df8d8$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $026145bf043df8d8$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $026145bf043df8d8$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $026145bf043df8d8$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $026145bf043df8d8$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $026145bf043df8d8$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $026145bf043df8d8$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $026145bf043df8d8$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $026145bf043df8d8$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $026145bf043df8d8$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $026145bf043df8d8$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}

});
parcelRegister("cGDM2", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $93c84288916af8d3$export$b3b2de96497acc47; });
$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $93c84288916af8d3$export$4b5284a3025a455; });
$parcel$export(module.exports, "getGlobal", function () { return $93c84288916af8d3$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "getDefaultEmulatorHostnameAndPort", function () { return $93c84288916af8d3$export$a3febcf1f14a3a0c; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $93c84288916af8d3$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "Deferred", function () { return $93c84288916af8d3$export$85f6557964517f1a; });
$parcel$export(module.exports, "isBrowser", function () { return $93c84288916af8d3$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $93c84288916af8d3$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $93c84288916af8d3$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $93c84288916af8d3$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "areCookiesEnabled", function () { return $93c84288916af8d3$export$f172b7eb6cf60599; });
$parcel$export(module.exports, "FirebaseError", function () { return $93c84288916af8d3$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $93c84288916af8d3$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "issuedAtTime", function () { return $93c84288916af8d3$export$701c661ec91095f2; });
$parcel$export(module.exports, "deepEqual", function () { return $93c84288916af8d3$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "uuidv4", function () { return $93c84288916af8d3$export$abe4376e1bf796d6; });
$parcel$export(module.exports, "calculateBackoffMillis", function () { return $93c84288916af8d3$export$4d810c0ca64ed8e9; });
$parcel$export(module.exports, "getModularInstance", function () { return $93c84288916af8d3$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $2bnlN = parcelRequire("2bnlN");
const $93c84288916af8d3$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $93c84288916af8d3$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $93c84288916af8d3$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $93c84288916af8d3$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $93c84288916af8d3$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $93c84288916af8d3$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $93c84288916af8d3$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $93c84288916af8d3$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($93c84288916af8d3$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $93c84288916af8d3$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $93c84288916af8d3$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $93c84288916af8d3$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $93c84288916af8d3$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $93c84288916af8d3$var$stringToByteArray$1(str);
    return $93c84288916af8d3$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $93c84288916af8d3$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $93c84288916af8d3$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $93c84288916af8d3$export$c62426fdd000a97e = function(str) {
    try {
        return $93c84288916af8d3$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $93c84288916af8d3$export$6c40052bed430212(value) {
    return $93c84288916af8d3$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $93c84288916af8d3$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$93c84288916af8d3$var$isValidKey(prop)) continue;
        target[prop] = $93c84288916af8d3$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $93c84288916af8d3$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $93c84288916af8d3$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $93c84288916af8d3$var$getDefaultsFromGlobal = ()=>$93c84288916af8d3$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $93c84288916af8d3$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $2bnlN === "undefined" || typeof $2bnlN.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $93c84288916af8d3$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $93c84288916af8d3$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $93c84288916af8d3$export$212bb2fc580a90a8 = ()=>{
    try {
        return $93c84288916af8d3$var$getDefaultsFromGlobal() || $93c84288916af8d3$var$getDefaultsFromEnvVariable() || $93c84288916af8d3$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $93c84288916af8d3$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $93c84288916af8d3$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $93c84288916af8d3$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $93c84288916af8d3$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $93c84288916af8d3$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $93c84288916af8d3$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $93c84288916af8d3$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $93c84288916af8d3$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $93c84288916af8d3$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $93c84288916af8d3$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $93c84288916af8d3$export$4b5284a3025a455(JSON.stringify(header)),
        $93c84288916af8d3$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $93c84288916af8d3$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $93c84288916af8d3$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($93c84288916af8d3$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $93c84288916af8d3$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $93c84288916af8d3$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $93c84288916af8d3$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $93c84288916af8d3$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $93c84288916af8d3$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $93c84288916af8d3$export$f2f6a8999f8ebd30() {
    return $93c84288916af8d3$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $93c84288916af8d3$export$7e7b1a9668aaed8() {
    const ua = $93c84288916af8d3$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $93c84288916af8d3$export$202944b2d2824246() {
    return $93c84288916af8d3$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $93c84288916af8d3$export$5d1d834fbbf8bab7() {
    return $93c84288916af8d3$export$588c7fdda06fbb0a.NODE_CLIENT === true || $93c84288916af8d3$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $93c84288916af8d3$export$95df08bae54cb4df() {
    return !$93c84288916af8d3$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $93c84288916af8d3$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $93c84288916af8d3$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $93c84288916af8d3$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $93c84288916af8d3$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $93c84288916af8d3$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $93c84288916af8d3$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $93c84288916af8d3$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $93c84288916af8d3$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $93c84288916af8d3$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $93c84288916af8d3$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $93c84288916af8d3$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $93c84288916af8d3$var$replaceTemplate(template, data) {
    return template.replace($93c84288916af8d3$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $93c84288916af8d3$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $93c84288916af8d3$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $93c84288916af8d3$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $93c84288916af8d3$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $93c84288916af8d3$export$c5a53ce6a17cf18d($93c84288916af8d3$export$c62426fdd000a97e(parts[0]) || "");
        claims = $93c84288916af8d3$export$c5a53ce6a17cf18d($93c84288916af8d3$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $93c84288916af8d3$export$5f870fcca7ae6a88 = function(token) {
    const claims = $93c84288916af8d3$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $93c84288916af8d3$export$701c661ec91095f2 = function(token) {
    const claims = $93c84288916af8d3$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $93c84288916af8d3$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $93c84288916af8d3$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $93c84288916af8d3$export$fc970ed23da99565 = function(token) {
    const claims = $93c84288916af8d3$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $93c84288916af8d3$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $93c84288916af8d3$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $93c84288916af8d3$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $93c84288916af8d3$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $93c84288916af8d3$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($93c84288916af8d3$var$isObject(aProp) && $93c84288916af8d3$var$isObject(bProp)) {
            if (!$93c84288916af8d3$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $93c84288916af8d3$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $93c84288916af8d3$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $93c84288916af8d3$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $93c84288916af8d3$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $93c84288916af8d3$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $93c84288916af8d3$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $93c84288916af8d3$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $93c84288916af8d3$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $93c84288916af8d3$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $93c84288916af8d3$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($93c84288916af8d3$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $93c84288916af8d3$var$noop;
        if (observer.error === undefined) observer.error = $93c84288916af8d3$var$noop;
        if (observer.complete === undefined) observer.complete = $93c84288916af8d3$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $93c84288916af8d3$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $93c84288916af8d3$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $93c84288916af8d3$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $93c84288916af8d3$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $93c84288916af8d3$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $93c84288916af8d3$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($93c84288916af8d3$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $93c84288916af8d3$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($93c84288916af8d3$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $93c84288916af8d3$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($93c84288916af8d3$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $93c84288916af8d3$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $93c84288916af8d3$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $93c84288916af8d3$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $93c84288916af8d3$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $93c84288916af8d3$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $93c84288916af8d3$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $93c84288916af8d3$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $93c84288916af8d3$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $93c84288916af8d3$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $93c84288916af8d3$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $93c84288916af8d3$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $93c84288916af8d3$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($93c84288916af8d3$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $93c84288916af8d3$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $93c84288916af8d3$var$indicator(i);
}
function $93c84288916af8d3$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $93c84288916af8d3$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRegister("2bnlN", function(module, exports) {
// shim for using process in browser
var $196eb8c7a47af0f9$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $196eb8c7a47af0f9$var$cachedSetTimeout;
var $196eb8c7a47af0f9$var$cachedClearTimeout;
function $196eb8c7a47af0f9$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $196eb8c7a47af0f9$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $196eb8c7a47af0f9$var$cachedSetTimeout = setTimeout;
        else $196eb8c7a47af0f9$var$cachedSetTimeout = $196eb8c7a47af0f9$var$defaultSetTimout;
    } catch (e) {
        $196eb8c7a47af0f9$var$cachedSetTimeout = $196eb8c7a47af0f9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $196eb8c7a47af0f9$var$cachedClearTimeout = clearTimeout;
        else $196eb8c7a47af0f9$var$cachedClearTimeout = $196eb8c7a47af0f9$var$defaultClearTimeout;
    } catch (e) {
        $196eb8c7a47af0f9$var$cachedClearTimeout = $196eb8c7a47af0f9$var$defaultClearTimeout;
    }
})();
function $196eb8c7a47af0f9$var$runTimeout(fun) {
    if ($196eb8c7a47af0f9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($196eb8c7a47af0f9$var$cachedSetTimeout === $196eb8c7a47af0f9$var$defaultSetTimout || !$196eb8c7a47af0f9$var$cachedSetTimeout) && setTimeout) {
        $196eb8c7a47af0f9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $196eb8c7a47af0f9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $196eb8c7a47af0f9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $196eb8c7a47af0f9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $196eb8c7a47af0f9$var$runClearTimeout(marker) {
    if ($196eb8c7a47af0f9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($196eb8c7a47af0f9$var$cachedClearTimeout === $196eb8c7a47af0f9$var$defaultClearTimeout || !$196eb8c7a47af0f9$var$cachedClearTimeout) && clearTimeout) {
        $196eb8c7a47af0f9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $196eb8c7a47af0f9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $196eb8c7a47af0f9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $196eb8c7a47af0f9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $196eb8c7a47af0f9$var$queue = [];
var $196eb8c7a47af0f9$var$draining = false;
var $196eb8c7a47af0f9$var$currentQueue;
var $196eb8c7a47af0f9$var$queueIndex = -1;
function $196eb8c7a47af0f9$var$cleanUpNextTick() {
    if (!$196eb8c7a47af0f9$var$draining || !$196eb8c7a47af0f9$var$currentQueue) return;
    $196eb8c7a47af0f9$var$draining = false;
    if ($196eb8c7a47af0f9$var$currentQueue.length) $196eb8c7a47af0f9$var$queue = $196eb8c7a47af0f9$var$currentQueue.concat($196eb8c7a47af0f9$var$queue);
    else $196eb8c7a47af0f9$var$queueIndex = -1;
    if ($196eb8c7a47af0f9$var$queue.length) $196eb8c7a47af0f9$var$drainQueue();
}
function $196eb8c7a47af0f9$var$drainQueue() {
    if ($196eb8c7a47af0f9$var$draining) return;
    var timeout = $196eb8c7a47af0f9$var$runTimeout($196eb8c7a47af0f9$var$cleanUpNextTick);
    $196eb8c7a47af0f9$var$draining = true;
    var len = $196eb8c7a47af0f9$var$queue.length;
    while(len){
        $196eb8c7a47af0f9$var$currentQueue = $196eb8c7a47af0f9$var$queue;
        $196eb8c7a47af0f9$var$queue = [];
        while(++$196eb8c7a47af0f9$var$queueIndex < len)if ($196eb8c7a47af0f9$var$currentQueue) $196eb8c7a47af0f9$var$currentQueue[$196eb8c7a47af0f9$var$queueIndex].run();
        $196eb8c7a47af0f9$var$queueIndex = -1;
        len = $196eb8c7a47af0f9$var$queue.length;
    }
    $196eb8c7a47af0f9$var$currentQueue = null;
    $196eb8c7a47af0f9$var$draining = false;
    $196eb8c7a47af0f9$var$runClearTimeout(timeout);
}
$196eb8c7a47af0f9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $196eb8c7a47af0f9$var$queue.push(new $196eb8c7a47af0f9$var$Item(fun, args));
    if ($196eb8c7a47af0f9$var$queue.length === 1 && !$196eb8c7a47af0f9$var$draining) $196eb8c7a47af0f9$var$runTimeout($196eb8c7a47af0f9$var$drainQueue);
};
// v8 likes predictible objects
function $196eb8c7a47af0f9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$196eb8c7a47af0f9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$196eb8c7a47af0f9$var$process.title = "browser";
$196eb8c7a47af0f9$var$process.browser = true;
$196eb8c7a47af0f9$var$process.env = {};
$196eb8c7a47af0f9$var$process.argv = [];
$196eb8c7a47af0f9$var$process.version = ""; // empty string to avoid regexp issues
$196eb8c7a47af0f9$var$process.versions = {};
function $196eb8c7a47af0f9$var$noop() {}
$196eb8c7a47af0f9$var$process.on = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.addListener = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.once = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.off = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.removeListener = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.removeAllListeners = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.emit = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.prependListener = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.prependOnceListener = $196eb8c7a47af0f9$var$noop;
$196eb8c7a47af0f9$var$process.listeners = function(name) {
    return [];
};
$196eb8c7a47af0f9$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$196eb8c7a47af0f9$var$process.cwd = function() {
    return "/";
};
$196eb8c7a47af0f9$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$196eb8c7a47af0f9$var$process.umask = function() {
    return 0;
};

});



parcelRegister("9plvI", function(module, exports) {

$parcel$export(module.exports, "Logger", function () { return $6d97226c3559e233$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $6d97226c3559e233$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $6d97226c3559e233$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $6d97226c3559e233$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $6d97226c3559e233$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($6d97226c3559e233$export$243e62d78d3b544d || ($6d97226c3559e233$export$243e62d78d3b544d = {}));
const $6d97226c3559e233$var$levelStringToEnum = {
    "debug": $6d97226c3559e233$export$243e62d78d3b544d.DEBUG,
    "verbose": $6d97226c3559e233$export$243e62d78d3b544d.VERBOSE,
    "info": $6d97226c3559e233$export$243e62d78d3b544d.INFO,
    "warn": $6d97226c3559e233$export$243e62d78d3b544d.WARN,
    "error": $6d97226c3559e233$export$243e62d78d3b544d.ERROR,
    "silent": $6d97226c3559e233$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $6d97226c3559e233$var$defaultLogLevel = $6d97226c3559e233$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $6d97226c3559e233$var$ConsoleMethod = {
    [$6d97226c3559e233$export$243e62d78d3b544d.DEBUG]: "log",
    [$6d97226c3559e233$export$243e62d78d3b544d.VERBOSE]: "log",
    [$6d97226c3559e233$export$243e62d78d3b544d.INFO]: "info",
    [$6d97226c3559e233$export$243e62d78d3b544d.WARN]: "warn",
    [$6d97226c3559e233$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $6d97226c3559e233$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $6d97226c3559e233$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $6d97226c3559e233$export$efa9a398d6368992 {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $6d97226c3559e233$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $6d97226c3559e233$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $6d97226c3559e233$export$243e62d78d3b544d.ERROR, ...args);
    }
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $6d97226c3559e233$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $6d97226c3559e233$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $6d97226c3559e233$var$instances.push(this);
    }
}
function $6d97226c3559e233$export$c622e99c0ce7b1c9(level) {
    $6d97226c3559e233$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $6d97226c3559e233$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $6d97226c3559e233$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $6d97226c3559e233$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $6d97226c3559e233$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("azjoc", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $7b1c3694b901a265$export$ca0ed41b1a2af7e; });

var $eiF5D = parcelRequire("eiF5D");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7b1c3694b901a265$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $eiF5D.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $eiF5D.w)(request.result), event.oldVersion, event.newVersion, (0, $eiF5D.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7b1c3694b901a265$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $eiF5D.w)(request).then(()=>undefined);
}
const $7b1c3694b901a265$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $7b1c3694b901a265$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $7b1c3694b901a265$var$cachedMethods = new Map();
function $7b1c3694b901a265$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($7b1c3694b901a265$var$cachedMethods.get(prop)) return $7b1c3694b901a265$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $7b1c3694b901a265$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7b1c3694b901a265$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7b1c3694b901a265$var$cachedMethods.set(prop, method);
    return method;
}
(0, $eiF5D.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7b1c3694b901a265$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7b1c3694b901a265$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("eiF5D", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $a6929eb9ef4414be$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $a6929eb9ef4414be$export$43caf9889c228507; });
const $a6929eb9ef4414be$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $a6929eb9ef4414be$var$idbProxyableTypes;
let $a6929eb9ef4414be$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $a6929eb9ef4414be$var$getIdbProxyableTypes() {
    return $a6929eb9ef4414be$var$idbProxyableTypes || ($a6929eb9ef4414be$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $a6929eb9ef4414be$var$getCursorAdvanceMethods() {
    return $a6929eb9ef4414be$var$cursorAdvanceMethods || ($a6929eb9ef4414be$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $a6929eb9ef4414be$var$cursorRequestMap = new WeakMap();
const $a6929eb9ef4414be$var$transactionDoneMap = new WeakMap();
const $a6929eb9ef4414be$var$transactionStoreNamesMap = new WeakMap();
const $a6929eb9ef4414be$var$transformCache = new WeakMap();
const $a6929eb9ef4414be$export$407448d2b89b1813 = new WeakMap();
function $a6929eb9ef4414be$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($a6929eb9ef4414be$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $a6929eb9ef4414be$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $a6929eb9ef4414be$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $a6929eb9ef4414be$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($a6929eb9ef4414be$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $a6929eb9ef4414be$var$transactionDoneMap.set(tx, done);
}
let $a6929eb9ef4414be$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $a6929eb9ef4414be$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $a6929eb9ef4414be$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $a6929eb9ef4414be$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $a6929eb9ef4414be$export$43caf9889c228507(callback) {
    $a6929eb9ef4414be$var$idbProxyTraps = callback($a6929eb9ef4414be$var$idbProxyTraps);
}
function $a6929eb9ef4414be$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($a6929eb9ef4414be$export$3b14a55fb2447963(this), storeNames, ...args);
        $a6929eb9ef4414be$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $a6929eb9ef4414be$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($a6929eb9ef4414be$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($a6929eb9ef4414be$export$3b14a55fb2447963(this), args);
        return $a6929eb9ef4414be$export$efccba1c4a2ef57b($a6929eb9ef4414be$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $a6929eb9ef4414be$export$efccba1c4a2ef57b(func.apply($a6929eb9ef4414be$export$3b14a55fb2447963(this), args));
    };
}
function $a6929eb9ef4414be$var$transformCachableValue(value) {
    if (typeof value === "function") return $a6929eb9ef4414be$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $a6929eb9ef4414be$var$cacheDonePromiseForTransaction(value);
    if ($a6929eb9ef4414be$export$23f2a1d2818174ef(value, $a6929eb9ef4414be$var$getIdbProxyableTypes())) return new Proxy(value, $a6929eb9ef4414be$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $a6929eb9ef4414be$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $a6929eb9ef4414be$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($a6929eb9ef4414be$var$transformCache.has(value)) return $a6929eb9ef4414be$var$transformCache.get(value);
    const newValue = $a6929eb9ef4414be$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $a6929eb9ef4414be$var$transformCache.set(value, newValue);
        $a6929eb9ef4414be$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $a6929eb9ef4414be$export$3b14a55fb2447963 = (value)=>$a6929eb9ef4414be$export$407448d2b89b1813.get(value);

});



parcelRegister("26KHD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc9bb0a99db65942$export$2e2bcd8739ae039; });
/**
 * Firebase application.
 * @see {@link https://firebase.google.com/docs/web/setup | Firebase · Add Firebase}
 */ parcelRequire("bm2WI");
var $6qld8 = parcelRequire("6qld8");

var $g5hEw = parcelRequire("g5hEw");

var $7eVPd = parcelRequire("7eVPd");
var /**
 * Firebase application.
 */ $cc9bb0a99db65942$export$2e2bcd8739ae039 = (0, $6qld8.initializeApp)((0, $7eVPd.default), (0, $g5hEw.siteName));

});
parcelRegister("bm2WI", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("6qld8")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("6qld8")).registerVersion; });

var $6qld8 = parcelRequire("6qld8");
var $844408cc00b12832$var$name = "firebase";
var $844408cc00b12832$var$version = "10.12.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $6qld8.registerVersion)($844408cc00b12832$var$name, $844408cc00b12832$var$version, "app");

});

parcelRegister("g5hEw", function(module, exports) {

$parcel$export(module.exports, "siteName", function () { return $8e2b52a44c677a4c$export$d00bfc95c1960322; });
$parcel$export(module.exports, "stateStorageKey", function () { return $8e2b52a44c677a4c$export$74aa7b1ec81e757c; });
$parcel$export(module.exports, "elmRootId", function () { return $8e2b52a44c677a4c$export$d72d6008bf50937b; });
/**
 * Application configuration.
 */ /**
 * The name of the website.
 */ const $8e2b52a44c677a4c$export$d00bfc95c1960322 = "nisavid.io";
const $8e2b52a44c677a4c$export$74aa7b1ec81e757c = "state";
const $8e2b52a44c677a4c$export$d72d6008bf50937b = "root";

});

parcelRegister("7eVPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22332c6ca456a4bb$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "recaptchaSiteKey", function () { return $22332c6ca456a4bb$export$ae0ab830b5f53f0a; });
/**
 * Firebase application configuration.
 */ var $22332c6ca456a4bb$export$2e2bcd8739ae039 = {
    apiKey: "AIzaSyDe_XJPmZHc_-u3XAmm4EqVdNmzm7pKAUw",
    authDomain: "xenon-sentry-395319.firebaseapp.com",
    projectId: "xenon-sentry-395319",
    storageBucket: "xenon-sentry-395319.firebasestorage.app",
    messagingSenderId: "475831902992",
    appId: "1:475831902992:web:c5bcfb144e7f3c77a1fb95",
    measurementId: "G-P503LJ3PJ0"
};
const $22332c6ca456a4bb$export$ae0ab830b5f53f0a = "6LcGkaEnAAAAAH3NC_Xg3K3Ac8eckDvVlNLufCsT";

});


parcelRegister("hxc2t", function(module, exports) {

var $icqoe = parcelRequire("icqoe");
module.exports = $icqoe("aqHNq").then(()=>parcelRequire("logfl"));

});
parcelRegister("icqoe", function(module, exports) {
"use strict";

function $d3fdd1767ffb8e64$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("giozE")).resolve(id));
}
module.exports = $d3fdd1767ffb8e64$var$load;

});


parcelRegister("7x21c", function(module, exports) {

var $icqoe = parcelRequire("icqoe");
module.exports = $icqoe("2Az7w").then(()=>parcelRequire("95bJ9"));

});


/**
 * Cloud functions.
 */ /**
 * Firebase analytics.
 * @see {@link https://firebase.google.com/docs/analytics/get-started?platform=web | Firebase · Get started with Google Analytics}
 */ 
var $6qld8 = parcelRequire("6qld8");

var $9plvI = parcelRequire("9plvI");

var $cGDM2 = parcelRequire("cGDM2");

var $cFrOI = parcelRequire("cFrOI");

var $6qld8 = parcelRequire("6qld8");

var $cFrOI = parcelRequire("cFrOI");

var $cGDM2 = parcelRequire("cGDM2");

var $azjoc = parcelRequire("azjoc");
const $879f7a15f7f83f0d$var$name = "@firebase/installations";
const $879f7a15f7f83f0d$var$version = "0.6.7";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $879f7a15f7f83f0d$var$PENDING_TIMEOUT_MS = 10000;
const $879f7a15f7f83f0d$var$PACKAGE_VERSION = `w:${$879f7a15f7f83f0d$var$version}`;
const $879f7a15f7f83f0d$var$INTERNAL_AUTH_VERSION = "FIS_v2";
const $879f7a15f7f83f0d$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const $879f7a15f7f83f0d$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $879f7a15f7f83f0d$var$SERVICE = "installations";
const $879f7a15f7f83f0d$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $879f7a15f7f83f0d$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: "Firebase Installation is not registered.",
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: "Firebase Installation not found.",
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: "Could not process request. Application offline.",
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $879f7a15f7f83f0d$var$ERROR_FACTORY = new (0, $cGDM2.ErrorFactory)($879f7a15f7f83f0d$var$SERVICE, $879f7a15f7f83f0d$var$SERVICE_NAME, $879f7a15f7f83f0d$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $879f7a15f7f83f0d$var$isServerError(error) {
    return error instanceof (0, $cGDM2.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $879f7a15f7f83f0d$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$879f7a15f7f83f0d$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $879f7a15f7f83f0d$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $879f7a15f7f83f0d$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $879f7a15f7f83f0d$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $879f7a15f7f83f0d$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $879f7a15f7f83f0d$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $879f7a15f7f83f0d$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $879f7a15f7f83f0d$var$getHeaders(appConfig);
    headers.append("Authorization", $879f7a15f7f83f0d$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $879f7a15f7f83f0d$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $879f7a15f7f83f0d$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $879f7a15f7f83f0d$var$getAuthorizationHeader(refreshToken) {
    return `${$879f7a15f7f83f0d$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $879f7a15f7f83f0d$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $879f7a15f7f83f0d$var$getInstallationsEndpoint(appConfig);
    const headers = $879f7a15f7f83f0d$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $879f7a15f7f83f0d$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $879f7a15f7f83f0d$var$PACKAGE_VERSION
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $879f7a15f7f83f0d$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $879f7a15f7f83f0d$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $879f7a15f7f83f0d$var$getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $879f7a15f7f83f0d$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $879f7a15f7f83f0d$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $879f7a15f7f83f0d$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $879f7a15f7f83f0d$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $879f7a15f7f83f0d$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $879f7a15f7f83f0d$var$encode(fidByteArray);
        return $879f7a15f7f83f0d$var$VALID_FID_PATTERN.test(fid) ? fid : $879f7a15f7f83f0d$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $879f7a15f7f83f0d$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $879f7a15f7f83f0d$var$encode(fidByteArray) {
    const b64String = $879f7a15f7f83f0d$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $879f7a15f7f83f0d$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $879f7a15f7f83f0d$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $879f7a15f7f83f0d$var$fidChanged(appConfig, fid) {
    const key = $879f7a15f7f83f0d$var$getKey(appConfig);
    $879f7a15f7f83f0d$var$callFidChangeCallbacks(key, fid);
    $879f7a15f7f83f0d$var$broadcastFidChange(key, fid);
}
function $879f7a15f7f83f0d$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $879f7a15f7f83f0d$var$getBroadcastChannel();
    const key = $879f7a15f7f83f0d$var$getKey(appConfig);
    let callbackSet = $879f7a15f7f83f0d$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $879f7a15f7f83f0d$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $879f7a15f7f83f0d$var$removeCallback(appConfig, callback) {
    const key = $879f7a15f7f83f0d$var$getKey(appConfig);
    const callbackSet = $879f7a15f7f83f0d$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $879f7a15f7f83f0d$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $879f7a15f7f83f0d$var$closeBroadcastChannel();
}
function $879f7a15f7f83f0d$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $879f7a15f7f83f0d$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $879f7a15f7f83f0d$var$broadcastFidChange(key, fid) {
    const channel = $879f7a15f7f83f0d$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $879f7a15f7f83f0d$var$closeBroadcastChannel();
}
let $879f7a15f7f83f0d$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $879f7a15f7f83f0d$var$getBroadcastChannel() {
    if (!$879f7a15f7f83f0d$var$broadcastChannel && "BroadcastChannel" in self) {
        $879f7a15f7f83f0d$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $879f7a15f7f83f0d$var$broadcastChannel.onmessage = (e)=>{
            $879f7a15f7f83f0d$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $879f7a15f7f83f0d$var$broadcastChannel;
}
function $879f7a15f7f83f0d$var$closeBroadcastChannel() {
    if ($879f7a15f7f83f0d$var$fidChangeCallbacks.size === 0 && $879f7a15f7f83f0d$var$broadcastChannel) {
        $879f7a15f7f83f0d$var$broadcastChannel.close();
        $879f7a15f7f83f0d$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $879f7a15f7f83f0d$var$DATABASE_NAME = "firebase-installations-database";
const $879f7a15f7f83f0d$var$DATABASE_VERSION = 1;
const $879f7a15f7f83f0d$var$OBJECT_STORE_NAME = "firebase-installations-store";
let $879f7a15f7f83f0d$var$dbPromise = null;
function $879f7a15f7f83f0d$var$getDbPromise() {
    if (!$879f7a15f7f83f0d$var$dbPromise) $879f7a15f7f83f0d$var$dbPromise = (0, $azjoc.openDB)($879f7a15f7f83f0d$var$DATABASE_NAME, $879f7a15f7f83f0d$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($879f7a15f7f83f0d$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $879f7a15f7f83f0d$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $879f7a15f7f83f0d$var$set(appConfig, value) {
    const key = $879f7a15f7f83f0d$var$getKey(appConfig);
    const db = await $879f7a15f7f83f0d$var$getDbPromise();
    const tx = db.transaction($879f7a15f7f83f0d$var$OBJECT_STORE_NAME, "readwrite");
    const objectStore = tx.objectStore($879f7a15f7f83f0d$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $879f7a15f7f83f0d$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $879f7a15f7f83f0d$var$remove(appConfig) {
    const key = $879f7a15f7f83f0d$var$getKey(appConfig);
    const db = await $879f7a15f7f83f0d$var$getDbPromise();
    const tx = db.transaction($879f7a15f7f83f0d$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($879f7a15f7f83f0d$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $879f7a15f7f83f0d$var$update(appConfig, updateFn) {
    const key = $879f7a15f7f83f0d$var$getKey(appConfig);
    const db = await $879f7a15f7f83f0d$var$getDbPromise();
    const tx = db.transaction($879f7a15f7f83f0d$var$OBJECT_STORE_NAME, "readwrite");
    const store = tx.objectStore($879f7a15f7f83f0d$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $879f7a15f7f83f0d$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $879f7a15f7f83f0d$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $879f7a15f7f83f0d$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $879f7a15f7f83f0d$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $879f7a15f7f83f0d$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $879f7a15f7f83f0d$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $879f7a15f7f83f0d$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $879f7a15f7f83f0d$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $879f7a15f7f83f0d$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $879f7a15f7f83f0d$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($879f7a15f7f83f0d$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $879f7a15f7f83f0d$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $879f7a15f7f83f0d$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $879f7a15f7f83f0d$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $879f7a15f7f83f0d$var$createInstallationRequest(installations, installationEntry);
        return $879f7a15f7f83f0d$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($879f7a15f7f83f0d$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $879f7a15f7f83f0d$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $879f7a15f7f83f0d$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $879f7a15f7f83f0d$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $879f7a15f7f83f0d$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $879f7a15f7f83f0d$var$sleep(100);
        entry = await $879f7a15f7f83f0d$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $879f7a15f7f83f0d$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $879f7a15f7f83f0d$var$updateInstallationRequest(appConfig) {
    return $879f7a15f7f83f0d$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $879f7a15f7f83f0d$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $879f7a15f7f83f0d$var$clearTimedOutRequest(oldEntry);
    });
}
function $879f7a15f7f83f0d$var$clearTimedOutRequest(entry) {
    if ($879f7a15f7f83f0d$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $879f7a15f7f83f0d$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $879f7a15f7f83f0d$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $879f7a15f7f83f0d$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $879f7a15f7f83f0d$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $879f7a15f7f83f0d$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $879f7a15f7f83f0d$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $879f7a15f7f83f0d$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $879f7a15f7f83f0d$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $879f7a15f7f83f0d$var$getErrorFromResponse("Generate Auth Token", response);
}
function $879f7a15f7f83f0d$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$879f7a15f7f83f0d$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $879f7a15f7f83f0d$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $879f7a15f7f83f0d$var$update(installations.appConfig, (oldEntry)=>{
        if (!$879f7a15f7f83f0d$var$isEntryRegistered(oldEntry)) throw $879f7a15f7f83f0d$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $879f7a15f7f83f0d$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $879f7a15f7f83f0d$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $879f7a15f7f83f0d$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $879f7a15f7f83f0d$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $879f7a15f7f83f0d$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $879f7a15f7f83f0d$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $879f7a15f7f83f0d$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $879f7a15f7f83f0d$var$sleep(100);
        entry = await $879f7a15f7f83f0d$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $879f7a15f7f83f0d$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $879f7a15f7f83f0d$var$updateAuthTokenRequest(appConfig) {
    return $879f7a15f7f83f0d$var$update(appConfig, (oldEntry)=>{
        if (!$879f7a15f7f83f0d$var$isEntryRegistered(oldEntry)) throw $879f7a15f7f83f0d$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($879f7a15f7f83f0d$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $879f7a15f7f83f0d$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $879f7a15f7f83f0d$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $879f7a15f7f83f0d$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($879f7a15f7f83f0d$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $879f7a15f7f83f0d$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $879f7a15f7f83f0d$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $879f7a15f7f83f0d$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $879f7a15f7f83f0d$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$879f7a15f7f83f0d$var$isAuthTokenExpired(authToken);
}
function $879f7a15f7f83f0d$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $879f7a15f7f83f0d$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $879f7a15f7f83f0d$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $879f7a15f7f83f0d$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $879f7a15f7f83f0d$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $879f7a15f7f83f0d$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $879f7a15f7f83f0d$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $879f7a15f7f83f0d$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $879f7a15f7f83f0d$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $879f7a15f7f83f0d$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $879f7a15f7f83f0d$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $879f7a15f7f83f0d$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $879f7a15f7f83f0d$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $879f7a15f7f83f0d$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $879f7a15f7f83f0d$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $879f7a15f7f83f0d$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: "DELETE",
        headers: headers
    };
    const response = await $879f7a15f7f83f0d$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $879f7a15f7f83f0d$var$getErrorFromResponse("Delete Installation", response);
}
function $879f7a15f7f83f0d$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$879f7a15f7f83f0d$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $879f7a15f7f83f0d$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $879f7a15f7f83f0d$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $879f7a15f7f83f0d$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $879f7a15f7f83f0d$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $879f7a15f7f83f0d$var$deleteInstallationRequest(appConfig, entry);
                await $879f7a15f7f83f0d$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $879f7a15f7f83f0d$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $879f7a15f7f83f0d$var$addCallback(appConfig, callback);
    return ()=>{
        $879f7a15f7f83f0d$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $879f7a15f7f83f0d$export$9bfc115e43431ff5(app = (0, $6qld8.getApp)()) {
    const installationsImpl = (0, $6qld8._getProvider)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $879f7a15f7f83f0d$var$extractAppConfig(app) {
    if (!app || !app.options) throw $879f7a15f7f83f0d$var$getMissingValueError("App Configuration");
    if (!app.name) throw $879f7a15f7f83f0d$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $879f7a15f7f83f0d$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $879f7a15f7f83f0d$var$getMissingValueError(valueName) {
    return $879f7a15f7f83f0d$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $879f7a15f7f83f0d$var$INSTALLATIONS_NAME = "installations";
const $879f7a15f7f83f0d$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const $879f7a15f7f83f0d$var$publicFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $879f7a15f7f83f0d$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $6qld8._getProvider)(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $879f7a15f7f83f0d$var$internalFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $6qld8._getProvider)(app, $879f7a15f7f83f0d$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$879f7a15f7f83f0d$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$879f7a15f7f83f0d$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $879f7a15f7f83f0d$var$registerInstallations() {
    (0, $6qld8._registerComponent)(new (0, $cFrOI.Component)($879f7a15f7f83f0d$var$INSTALLATIONS_NAME, $879f7a15f7f83f0d$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $6qld8._registerComponent)(new (0, $cFrOI.Component)($879f7a15f7f83f0d$var$INSTALLATIONS_NAME_INTERNAL, $879f7a15f7f83f0d$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $879f7a15f7f83f0d$var$registerInstallations();
(0, $6qld8.registerVersion)($879f7a15f7f83f0d$var$name, $879f7a15f7f83f0d$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $6qld8.registerVersion)($879f7a15f7f83f0d$var$name, $879f7a15f7f83f0d$var$version, "esm2017");


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $c717cf3db7ca364d$var$ANALYTICS_TYPE = "analytics";
// Key to attach FID to in gtag params.
const $c717cf3db7ca364d$var$GA_FID_KEY = "firebase_id";
const $c717cf3db7ca364d$var$ORIGIN_KEY = "origin";
const $c717cf3db7ca364d$var$FETCH_TIMEOUT_MILLIS = 60000;
const $c717cf3db7ca364d$var$DYNAMIC_CONFIG_URL = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig";
const $c717cf3db7ca364d$var$GTAG_URL = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c717cf3db7ca364d$var$logger = new (0, $9plvI.Logger)("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c717cf3db7ca364d$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: "Firebase Analytics Interop Component failed to instantiate: {$reason}",
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}",
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: "Trusted Types detected an invalid gtag resource: {$gtagURL}."
};
const $c717cf3db7ca364d$var$ERROR_FACTORY = new (0, $cGDM2.ErrorFactory)("analytics", "Analytics", $c717cf3db7ca364d$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $c717cf3db7ca364d$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($c717cf3db7ca364d$var$GTAG_URL)) {
        const err = $c717cf3db7ca364d$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $c717cf3db7ca364d$var$logger.warn(err.message);
        return "";
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $c717cf3db7ca364d$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $c717cf3db7ca364d$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $c717cf3db7ca364d$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $c717cf3db7ca364d$var$createTrustedTypesPolicy("firebase-js-sdk-policy", {
        createScriptURL: $c717cf3db7ca364d$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement("script");
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$c717cf3db7ca364d$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $c717cf3db7ca364d$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $c717cf3db7ca364d$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $c717cf3db7ca364d$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $c717cf3db7ca364d$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $c717cf3db7ca364d$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams["send_to"]) {
            let gaSendToList = gtagParams["send_to"];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $c717cf3db7ca364d$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $c717cf3db7ca364d$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $c717cf3db7ca364d$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $c717cf3db7ca364d$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $c717cf3db7ca364d$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $c717cf3db7ca364d$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $c717cf3db7ca364d$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === "function") // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $c717cf3db7ca364d$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $c717cf3db7ca364d$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName("script");
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($c717cf3db7ca364d$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $c717cf3db7ca364d$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $c717cf3db7ca364d$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $c717cf3db7ca364d$var$RetryData {
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
    constructor(throttleMetadata = {}, intervalMillis = $c717cf3db7ca364d$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
}
const $c717cf3db7ca364d$var$defaultRetryData = new $c717cf3db7ca364d$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $c717cf3db7ca364d$var$getHeaders(apiKey) {
    return new Headers({
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $c717cf3db7ca364d$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: "GET",
        headers: $c717cf3db7ca364d$var$getHeaders(apiKey)
    };
    const appUrl = $c717cf3db7ca364d$var$DYNAMIC_CONFIG_URL.replace("{app-id}", appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = "";
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $c717cf3db7ca364d$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $c717cf3db7ca364d$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $c717cf3db7ca364d$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $c717cf3db7ca364d$var$FETCH_TIMEOUT_MILLIS);
    return $c717cf3db7ca364d$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $c717cf3db7ca364d$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $c717cf3db7ca364d$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $c717cf3db7ca364d$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $c717cf3db7ca364d$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $c717cf3db7ca364d$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$c717cf3db7ca364d$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $c717cf3db7ca364d$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $cGDM2.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $c717cf3db7ca364d$var$LONG_RETRY_FACTOR) : (0, $cGDM2.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $c717cf3db7ca364d$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $c717cf3db7ca364d$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $c717cf3db7ca364d$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($c717cf3db7ca364d$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $c717cf3db7ca364d$var$isRetriableError(e) {
    if (!(e instanceof (0, $cGDM2.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData["httpStatus"]);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $c717cf3db7ca364d$var$AnalyticsAbortSignal {
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
    constructor(){
        this.listeners = [];
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $c717cf3db7ca364d$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $c717cf3db7ca364d$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            "send_to": measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $c717cf3db7ca364d$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "screen_name": screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "screen_name": screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $c717cf3db7ca364d$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            "user_id": id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_id": id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $c717cf3db7ca364d$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            "user_properties": properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $c717cf3db7ca364d$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, "client_id", (clientId)=>{
            if (!clientId) reject($c717cf3db7ca364d$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $c717cf3db7ca364d$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $c717cf3db7ca364d$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $c717cf3db7ca364d$var$_setConsentDefaultForInit(consentSettings) {
    $c717cf3db7ca364d$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $c717cf3db7ca364d$var$_setDefaultEventParametersForInit(customParams) {
    $c717cf3db7ca364d$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c717cf3db7ca364d$var$validateIndexedDB() {
    if (!(0, $cGDM2.isIndexedDBAvailable)()) {
        $c717cf3db7ca364d$var$logger.warn($c717cf3db7ca364d$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: "IndexedDB is not available in this environment."
        }).message);
        return false;
    } else try {
        await (0, $cGDM2.validateIndexedDBOpenable)();
    } catch (e) {
        $c717cf3db7ca364d$var$logger.warn($c717cf3db7ca364d$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $c717cf3db7ca364d$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $c717cf3db7ca364d$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $c717cf3db7ca364d$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$c717cf3db7ca364d$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $c717cf3db7ca364d$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$c717cf3db7ca364d$var$findGtagScriptOnPage(dataLayerName)) $c717cf3db7ca364d$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($c717cf3db7ca364d$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , "default", $c717cf3db7ca364d$var$defaultConsentSettingsForInit);
        $c717cf3db7ca364d$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore("js", new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$c717cf3db7ca364d$var$ORIGIN_KEY] = "firebase";
    configProperties.update = true;
    if (fid != null) configProperties[$c717cf3db7ca364d$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($c717cf3db7ca364d$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $c717cf3db7ca364d$var$defaultEventParametersForInit);
        $c717cf3db7ca364d$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $c717cf3db7ca364d$var$AnalyticsService {
    _delete() {
        delete $c717cf3db7ca364d$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
    constructor(app){
        this.app = app;
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $c717cf3db7ca364d$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $c717cf3db7ca364d$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $c717cf3db7ca364d$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $c717cf3db7ca364d$var$dataLayerName = "dataLayer";
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $c717cf3db7ca364d$var$gtagName = "gtag";
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $c717cf3db7ca364d$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $c717cf3db7ca364d$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $c717cf3db7ca364d$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $c717cf3db7ca364d$export$a5a6e0b888b2c992(options) {
    if ($c717cf3db7ca364d$var$globalInitDone) throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $c717cf3db7ca364d$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $c717cf3db7ca364d$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $c717cf3db7ca364d$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $cGDM2.isBrowserExtension)()) mismatchedEnvMessages.push("This is a browser extension environment.");
    if (!(0, $cGDM2.areCookiesEnabled)()) mismatchedEnvMessages.push("Cookies are not available.");
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(" ");
        const err = $c717cf3db7ca364d$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $c717cf3db7ca364d$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $c717cf3db7ca364d$var$factory(app, installations, options) {
    $c717cf3db7ca364d$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $c717cf3db7ca364d$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($c717cf3db7ca364d$var$initializationPromisesMap[appId] != null) throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$c717cf3db7ca364d$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $c717cf3db7ca364d$var$getOrCreateDataLayer($c717cf3db7ca364d$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $c717cf3db7ca364d$var$wrapOrCreateGtag($c717cf3db7ca364d$var$initializationPromisesMap, $c717cf3db7ca364d$var$dynamicConfigPromisesList, $c717cf3db7ca364d$var$measurementIdToAppId, $c717cf3db7ca364d$var$dataLayerName, $c717cf3db7ca364d$var$gtagName);
        $c717cf3db7ca364d$var$wrappedGtagFunction = wrappedGtag;
        $c717cf3db7ca364d$var$gtagCoreFunction = gtagCore;
        $c717cf3db7ca364d$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $c717cf3db7ca364d$var$initializationPromisesMap[appId] = $c717cf3db7ca364d$var$_initializeAnalytics(app, $c717cf3db7ca364d$var$dynamicConfigPromisesList, $c717cf3db7ca364d$var$measurementIdToAppId, installations, $c717cf3db7ca364d$var$gtagCoreFunction, $c717cf3db7ca364d$var$dataLayerName, options);
    const analyticsInstance = new $c717cf3db7ca364d$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $c717cf3db7ca364d$export$b0297573c90085aa(app = (0, $6qld8.getApp)()) {
    app = (0, $cGDM2.getModularInstance)(app);
    // Dependencies
    const analyticsProvider = (0, $6qld8._getProvider)(app, $c717cf3db7ca364d$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $c717cf3db7ca364d$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $c717cf3db7ca364d$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $6qld8._getProvider)(app, $c717cf3db7ca364d$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $cGDM2.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $c717cf3db7ca364d$export$48c17662a6902497() {
    if ((0, $cGDM2.isBrowserExtension)()) return false;
    if (!(0, $cGDM2.areCookiesEnabled)()) return false;
    if (!(0, $cGDM2.isIndexedDBAvailable)()) return false;
    try {
        const isDBOpenable = await (0, $cGDM2.validateIndexedDBOpenable)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $c717cf3db7ca364d$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $cGDM2.getModularInstance)(analyticsInstance);
    $c717cf3db7ca364d$var$setCurrentScreen$1($c717cf3db7ca364d$var$wrappedGtagFunction, $c717cf3db7ca364d$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$c717cf3db7ca364d$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $c717cf3db7ca364d$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $cGDM2.getModularInstance)(analyticsInstance);
    return $c717cf3db7ca364d$var$internalGetGoogleAnalyticsClientId($c717cf3db7ca364d$var$wrappedGtagFunction, $c717cf3db7ca364d$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $c717cf3db7ca364d$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $cGDM2.getModularInstance)(analyticsInstance);
    $c717cf3db7ca364d$var$setUserId$1($c717cf3db7ca364d$var$wrappedGtagFunction, $c717cf3db7ca364d$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$c717cf3db7ca364d$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $c717cf3db7ca364d$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $cGDM2.getModularInstance)(analyticsInstance);
    $c717cf3db7ca364d$var$setUserProperties$1($c717cf3db7ca364d$var$wrappedGtagFunction, $c717cf3db7ca364d$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$c717cf3db7ca364d$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $c717cf3db7ca364d$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $cGDM2.getModularInstance)(analyticsInstance);
    $c717cf3db7ca364d$var$setAnalyticsCollectionEnabled$1($c717cf3db7ca364d$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$c717cf3db7ca364d$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $c717cf3db7ca364d$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($c717cf3db7ca364d$var$wrappedGtagFunction) $c717cf3db7ca364d$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $c717cf3db7ca364d$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $c717cf3db7ca364d$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $cGDM2.getModularInstance)(analyticsInstance);
    $c717cf3db7ca364d$var$logEvent$1($c717cf3db7ca364d$var$wrappedGtagFunction, $c717cf3db7ca364d$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$c717cf3db7ca364d$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $c717cf3db7ca364d$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($c717cf3db7ca364d$var$wrappedGtagFunction) $c717cf3db7ca364d$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , "update", consentSettings);
    else $c717cf3db7ca364d$var$_setConsentDefaultForInit(consentSettings);
}
const $c717cf3db7ca364d$var$name = "@firebase/analytics";
const $c717cf3db7ca364d$var$version = "0.10.4";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $c717cf3db7ca364d$var$registerAnalytics() {
    (0, $6qld8._registerComponent)(new (0, $cFrOI.Component)($c717cf3db7ca364d$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider("app").getImmediate();
        const installations = container.getProvider("installations-internal").getImmediate();
        return $c717cf3db7ca364d$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $6qld8._registerComponent)(new (0, $cFrOI.Component)("analytics-internal", internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $6qld8.registerVersion)($c717cf3db7ca364d$var$name, $c717cf3db7ca364d$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $6qld8.registerVersion)($c717cf3db7ca364d$var$name, $c717cf3db7ca364d$var$version, "esm2017");
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($c717cf3db7ca364d$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$c717cf3db7ca364d$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $c717cf3db7ca364d$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$c717cf3db7ca364d$var$registerAnalytics();





var $26KHD = parcelRequire("26KHD");
/**
 * Firebase analytics.
 */ const $6c5e0b5e87abddb0$var$analytics = (0, $c717cf3db7ca364d$export$b0297573c90085aa)((0, $26KHD.default));
var $6c5e0b5e87abddb0$export$2e2bcd8739ae039 = $6c5e0b5e87abddb0$var$analytics;
/**
 * Log an analytics event.
 * @param {Shift<Parameters<typeof logEvent>>} args - Event arguments.
 */ function $6c5e0b5e87abddb0$export$5e9eec8001665ac5(...args) {
    if ($6c5e0b5e87abddb0$var$analytics) (0, $c717cf3db7ca364d$export$5e9eec8001665ac5)($6c5e0b5e87abddb0$var$analytics, ...args);
    else console.log("Analytics event:", ...args);
}



function $c0309db34c5713de$export$5e26890bf91986b4(params) {
    return new Promise((resolve, reject)=>{
        (parcelRequire("hxc2t")).then(({ cloudFunction: cloudFunction })=>{
            const sendContactFormEmail = cloudFunction("sendContactFormEmail");
            sendContactFormEmail(params).then(()=>{
                $6c5e0b5e87abddb0$export$5e9eec8001665ac5("generateLead");
                resolve();
            }).catch((error)=>{
                reject(error);
            });
        });
    });
}



var $g5hEw = parcelRequire("g5hEw");
/**
 * Interface with the user's device.
 */ const $2d6202cc1958cad9$var$prefersLightColorSchemeMediaQuery = window.matchMedia("(prefers-color-scheme: light)");
const $2d6202cc1958cad9$var$prefersDarkColorSchemeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
function $2d6202cc1958cad9$export$c73dcf559dad2f44() {
    /**
   * Get the device's preferred color scheme.
   * @returns {"light" | "dark" | null} The device's preferred color scheme.
   */ function getPrefersColorScheme() {
        if ($2d6202cc1958cad9$var$prefersLightColorSchemeMediaQuery.matches) return "light";
        else if ($2d6202cc1958cad9$var$prefersDarkColorSchemeMediaQuery.matches) return "dark";
        else return null;
    }
    return {
        prefersColorScheme: getPrefersColorScheme()
    };
}
function $2d6202cc1958cad9$export$1e04eab7cef66ad5(callback) {
    /**
   * Call the callback with the device information.
   */ function callbackWithInfo() {
        callback($2d6202cc1958cad9$export$c73dcf559dad2f44());
    }
    $2d6202cc1958cad9$var$prefersLightColorSchemeMediaQuery.addEventListener("change", callbackWithInfo);
    $2d6202cc1958cad9$var$prefersDarkColorSchemeMediaQuery.addEventListener("change", callbackWithInfo);
}


/**
 * Interface with the Document Object Model (DOM).
 */ /**
 * Formatting.
 */ /**
 * A tag function that safely quotes all interpolated values.
 * @param {TemplateStringsArray} strings - The string parts of the template literal.
 * @param {...unknown} values - The interpolated values.
 * @returns {string} The resulting string.
 */ function $2fee3baa140f2968$export$9e5f44173e64f162(strings, ...values) {
    return strings.reduce((acc, curr, i)=>{
        acc += curr;
        if (i < values.length) acc += JSON.stringify(values[i]);
        return acc;
    }, "");
}


let $7f17118e49d273d4$var$_ = (t)=>t, $7f17118e49d273d4$var$t, $7f17118e49d273d4$var$t1, $7f17118e49d273d4$var$t2;
function $7f17118e49d273d4$export$b61bda4fbca264f2() {
    for (const class_ of [
        HTMLButtonElement,
        HTMLInputElement,
        HTMLSelectElement,
        HTMLTextAreaElement
    ])if (!("customValidity" in class_.prototype)) Object.defineProperty(class_.prototype, "customValidity", {
        get () {
            return this.validationMessage;
        },
        set (value) {
            this.setCustomValidity(value);
        }
    });
}
function $7f17118e49d273d4$export$50d70f8cedc54453(id) {
    return new Promise((resolve, reject)=>{
        const element = document.getElementById(id);
        try {
            if (element == null) throw new Error((0, $2fee3baa140f2968$export$9e5f44173e64f162)($7f17118e49d273d4$var$t || ($7f17118e49d273d4$var$t = $7f17118e49d273d4$var$_`Element with ID ${0} not found`), id));
            if (!("checkValidity" in element) || typeof element.checkValidity !== "function") throw new Error((0, $2fee3baa140f2968$export$9e5f44173e64f162)($7f17118e49d273d4$var$t1 || ($7f17118e49d273d4$var$t1 = $7f17118e49d273d4$var$_`Element with ID ${0} does not have a checkValidity method`), id));
            if (!("validity" in element) || !(element.validity instanceof ValidityState)) throw new Error((0, $2fee3baa140f2968$export$9e5f44173e64f162)($7f17118e49d273d4$var$t2 || ($7f17118e49d273d4$var$t2 = $7f17118e49d273d4$var$_`Element with ID ${0} does not have a validity property`), id));
            element.checkValidity();
            resolve(element.validity);
        } catch (exc) {
            reject(exc);
        }
    });
}


/**
 * Persistent storage.
 */ 
var $g5hEw = parcelRequire("g5hEw");
/**
 * Errors.
 */ /**
 * An error that occurs when a value is invalid.
 */ class $2aaa3c4d8e18bc1a$export$2191b9da168c6cf0 extends Error {
    /**
   * @param {string} message - The error message.
   * @param {unknown} value - The invalid value that caused the error.
   */ constructor(message, value){
        super(message);
        this.name = "ValidationError";
        this.value = value;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $2aaa3c4d8e18bc1a$export$2191b9da168c6cf0);
    }
}



let $1c2cb310b7d342e3$var$_ = (t)=>t, $1c2cb310b7d342e3$var$t, $1c2cb310b7d342e3$var$t1, $1c2cb310b7d342e3$var$t2, $1c2cb310b7d342e3$var$t3;
/**
 * Validate the given value as a `PersistentState`.
 * @param {unknown} value - The value to validate.
 * @returns {PersistentState} The validated value.
 * @throws {ValidationError}
 *   If the value is not a valid `PersistentState`.
 */ function $1c2cb310b7d342e3$var$validatePersistentState(value) {
    if (value !== null && typeof value === "object" && "settings" in value && value.settings !== null && typeof value.settings === "object" && "theme" in value.settings && (value.settings.theme === "system" || value.settings.theme === "light" || value.settings.theme === "dark")) return value;
    else throw new (0, $2aaa3c4d8e18bc1a$export$2191b9da168c6cf0)("Invalid persistent state", value);
}
function $1c2cb310b7d342e3$export$d2f44a0250447fe3(type) {
    const storage = window[type];
    const x = "__storage_test__";
    try {
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (exc) {
        return exc instanceof DOMException && (exc.name === "QuotaExceededError" || exc.name === "NS_ERROR_DOM_QUOTA_REACHED") && (storage === null || storage === void 0 ? void 0 : storage.length) !== 0;
    }
}
function $1c2cb310b7d342e3$export$50fdfeece43146fd() {
    if ($1c2cb310b7d342e3$export$d2f44a0250447fe3("localStorage")) try {
        const stateJson = window.localStorage.getItem((0, $g5hEw.stateStorageKey));
        if (stateJson != null) try {
            return $1c2cb310b7d342e3$var$validatePersistentState(JSON.parse(stateJson));
        } catch (exc) {
            console.error((0, $2fee3baa140f2968$export$9e5f44173e64f162)($1c2cb310b7d342e3$var$t || ($1c2cb310b7d342e3$var$t = $1c2cb310b7d342e3$var$_`Invalid persistent state in local storage at key ${0}:`), (0, $g5hEw.stateStorageKey)), exc instanceof (0, $2aaa3c4d8e18bc1a$export$2191b9da168c6cf0) ? exc.value : stateJson, "\n", exc);
        }
    } catch (exc) {
        console.error((0, $2fee3baa140f2968$export$9e5f44173e64f162)($1c2cb310b7d342e3$var$t1 || ($1c2cb310b7d342e3$var$t1 = $1c2cb310b7d342e3$var$_`Cannot retrieve persistent state from local storage at key ${0}:`), (0, $g5hEw.stateStorageKey)), "\n", exc);
    }
    return null;
}
function $1c2cb310b7d342e3$export$42fffed799c298bb(state) {
    try {
        if (state === null) window.localStorage.removeItem((0, $g5hEw.stateStorageKey));
        else window.localStorage.setItem((0, $g5hEw.stateStorageKey), JSON.stringify(state));
    } catch (exc) {
        console.error((0, $2fee3baa140f2968$export$9e5f44173e64f162)($1c2cb310b7d342e3$var$t2 || ($1c2cb310b7d342e3$var$t2 = $1c2cb310b7d342e3$var$_`Cannot store persistent state in local storage at key ${0}:`), (0, $g5hEw.stateStorageKey)), state, "\n", exc);
    }
}
function $1c2cb310b7d342e3$export$219681ab961e5694(callback) {
    window.addEventListener("storage", function(event) {
        if (event.storageArea === window.localStorage && event.key === (0, $g5hEw.stateStorageKey)) {
            let newValue = null;
            try {
                newValue = event.newValue != null ? $1c2cb310b7d342e3$var$validatePersistentState(JSON.parse(event.newValue)) : null;
            } catch (exc) {
                console.error((0, $2fee3baa140f2968$export$9e5f44173e64f162)($1c2cb310b7d342e3$var$t3 || ($1c2cb310b7d342e3$var$t3 = $1c2cb310b7d342e3$var$_`Invalid persistent state in local storage at key ${0}:`), (0, $g5hEw.stateStorageKey)), exc instanceof (0, $2aaa3c4d8e18bc1a$export$2191b9da168c6cf0) ? exc.value : event.newValue, "\n", exc);
                return;
            }
            callback(newValue);
        }
    }, false);
}


/**
 * Web Vitals.
 * @see {@link https://web.dev/articles/vitals/ | Web Vitals}
 */ /*
 Copyright 2022 Google LLC
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/ // Creates the `web-vitals/attribution` import in node-based bundlers.
// This will not be needed when export maps are widely supported.
var $a3d672efac30742f$var$t, $a3d672efac30742f$var$e, $a3d672efac30742f$var$n = function() {
    var t = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, $a3d672efac30742f$var$r = function(t) {
    if ("loading" === document.readyState) return "loading";
    var e = $a3d672efac30742f$var$n();
    if (e) {
        if (t < e.domInteractive) return "loading";
        if (0 === e.domContentLoadedEventStart || t < e.domContentLoadedEventStart) return "dom-interactive";
        if (0 === e.domComplete || t < e.domComplete) return "dom-content-loaded";
    }
    return "complete";
}, $a3d672efac30742f$var$i = function(t) {
    var e = t.nodeName;
    return 1 === t.nodeType ? e.toLowerCase() : e.toUpperCase().replace(/^#/, "");
}, $a3d672efac30742f$var$a = function(t, e) {
    var n = "";
    try {
        for(; t && 9 !== t.nodeType;){
            var r = t, a = r.id ? "#" + r.id : $a3d672efac30742f$var$i(r) + (r.classList && r.classList.value && r.classList.value.trim() && r.classList.value.trim().length ? "." + r.classList.value.trim().replace(/\s+/g, ".") : "");
            if (n.length + a.length > (e || 100) - 1) return n || a;
            if (n = n ? a + ">" + n : a, r.id) break;
            t = r.parentNode;
        }
    } catch (t) {}
    return n;
}, $a3d672efac30742f$var$o = -1, $a3d672efac30742f$var$c = function() {
    return $a3d672efac30742f$var$o;
}, $a3d672efac30742f$var$u = function(t) {
    addEventListener("pageshow", function(e) {
        e.persisted && ($a3d672efac30742f$var$o = e.timeStamp, t(e));
    }, !0);
}, $a3d672efac30742f$var$s = function() {
    var t = $a3d672efac30742f$var$n();
    return t && t.activationStart || 0;
}, $a3d672efac30742f$var$f = function(t, e) {
    var r = $a3d672efac30742f$var$n(), i = "navigate";
    $a3d672efac30742f$var$c() >= 0 ? i = "back-forward-cache" : r && (document.prerendering || $a3d672efac30742f$var$s() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : r.type && (i = r.type.replace(/_/g, "-")));
    return {
        name: t,
        value: void 0 === e ? -1 : e,
        rating: "good",
        delta: 0,
        entries: [],
        id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
        navigationType: i
    };
}, $a3d672efac30742f$var$d = function(t, e, n) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(t)) {
            var r = new PerformanceObserver(function(t) {
                Promise.resolve().then(function() {
                    e(t.getEntries());
                });
            });
            return r.observe(Object.assign({
                type: t,
                buffered: !0
            }, n || {})), r;
        }
    } catch (t) {}
}, $a3d672efac30742f$var$l = function(t, e, n, r) {
    var i, a;
    return function(o) {
        e.value >= 0 && (o || r) && ((a = e.value - (i || 0)) || void 0 === i) && (i = e.value, e.delta = a, e.rating = function(t, e) {
            return t > e[1] ? "poor" : t > e[0] ? "needs-improvement" : "good";
        }(e.value, n), t(e));
    };
}, $a3d672efac30742f$var$m = function(t) {
    requestAnimationFrame(function() {
        return requestAnimationFrame(function() {
            return t();
        });
    });
}, $a3d672efac30742f$var$p = function(t) {
    document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && t();
    });
}, $a3d672efac30742f$var$v = function(t) {
    var e = !1;
    return function() {
        e || (t(), e = !0);
    };
}, $a3d672efac30742f$var$g = -1, $a3d672efac30742f$var$h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
}, $a3d672efac30742f$var$T = function(t) {
    "hidden" === document.visibilityState && $a3d672efac30742f$var$g > -1 && ($a3d672efac30742f$var$g = "visibilitychange" === t.type ? t.timeStamp : 0, $a3d672efac30742f$var$E());
}, $a3d672efac30742f$var$y = function() {
    addEventListener("visibilitychange", $a3d672efac30742f$var$T, !0), addEventListener("prerenderingchange", $a3d672efac30742f$var$T, !0);
}, $a3d672efac30742f$var$E = function() {
    removeEventListener("visibilitychange", $a3d672efac30742f$var$T, !0), removeEventListener("prerenderingchange", $a3d672efac30742f$var$T, !0);
}, $a3d672efac30742f$var$S = function() {
    return $a3d672efac30742f$var$g < 0 && ($a3d672efac30742f$var$g = $a3d672efac30742f$var$h(), $a3d672efac30742f$var$y(), $a3d672efac30742f$var$u(function() {
        setTimeout(function() {
            $a3d672efac30742f$var$g = $a3d672efac30742f$var$h(), $a3d672efac30742f$var$y();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $a3d672efac30742f$var$g;
        }
    };
}, $a3d672efac30742f$var$b = function(t) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
        return t();
    }, !0) : t();
}, $a3d672efac30742f$export$e610c735b5510cec = [
    1800,
    3e3
], $a3d672efac30742f$var$C = function(t, e) {
    e = e || {}, $a3d672efac30742f$var$b(function() {
        var n, r = $a3d672efac30742f$var$S(), i = $a3d672efac30742f$var$f("FCP"), a = $a3d672efac30742f$var$d("paint", function(t) {
            t.forEach(function(t) {
                "first-contentful-paint" === t.name && (a.disconnect(), t.startTime < r.firstHiddenTime && (i.value = Math.max(t.startTime - $a3d672efac30742f$var$s(), 0), i.entries.push(t), n(!0)));
            });
        });
        a && (n = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$e610c735b5510cec, e.reportAllChanges), $a3d672efac30742f$var$u(function(r) {
            i = $a3d672efac30742f$var$f("FCP"), n = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$e610c735b5510cec, e.reportAllChanges), $a3d672efac30742f$var$m(function() {
                i.value = performance.now() - r.timeStamp, n(!0);
            });
        }));
    });
}, $a3d672efac30742f$export$3f20d8e089ac35b2 = [
    .1,
    .25
], $a3d672efac30742f$export$a7873055838e5ad8 = function(t, e) {
    !function(t, e) {
        e = e || {}, $a3d672efac30742f$var$C($a3d672efac30742f$var$v(function() {
            var n, r = $a3d672efac30742f$var$f("CLS", 0), i = 0, a = [], o = function(t) {
                t.forEach(function(t) {
                    if (!t.hadRecentInput) {
                        var e = a[0], n = a[a.length - 1];
                        i && t.startTime - n.startTime < 1e3 && t.startTime - e.startTime < 5e3 ? (i += t.value, a.push(t)) : (i = t.value, a = [
                            t
                        ]);
                    }
                }), i > r.value && (r.value = i, r.entries = a, n());
            }, c = $a3d672efac30742f$var$d("layout-shift", o);
            c && (n = $a3d672efac30742f$var$l(t, r, $a3d672efac30742f$export$3f20d8e089ac35b2, e.reportAllChanges), $a3d672efac30742f$var$p(function() {
                o(c.takeRecords()), n(!0);
            }), $a3d672efac30742f$var$u(function() {
                i = 0, r = $a3d672efac30742f$var$f("CLS", 0), n = $a3d672efac30742f$var$l(t, r, $a3d672efac30742f$export$3f20d8e089ac35b2, e.reportAllChanges), $a3d672efac30742f$var$m(function() {
                    return n();
                });
            }), setTimeout(n, 0));
        }));
    }(function(e) {
        var n = function(t) {
            var e, n = {};
            if (t.entries.length) {
                var i = t.entries.reduce(function(t, e) {
                    return t && t.value > e.value ? t : e;
                });
                if (i && i.sources && i.sources.length) {
                    var o = (e = i.sources).find(function(t) {
                        return t.node && 1 === t.node.nodeType;
                    }) || e[0];
                    o && (n = {
                        largestShiftTarget: $a3d672efac30742f$var$a(o.node),
                        largestShiftTime: i.startTime,
                        largestShiftValue: i.value,
                        largestShiftSource: o,
                        largestShiftEntry: i,
                        loadState: $a3d672efac30742f$var$r(i.startTime)
                    });
                }
            }
            return Object.assign(t, {
                attribution: n
            });
        }(e);
        t(n);
    }, e);
}, $a3d672efac30742f$export$fe3c86b74e15d5de = function(t, e) {
    $a3d672efac30742f$var$C(function(e) {
        var i = function(t) {
            var e = {
                timeToFirstByte: 0,
                firstByteToFCP: t.value,
                loadState: $a3d672efac30742f$var$r($a3d672efac30742f$var$c())
            };
            if (t.entries.length) {
                var i = $a3d672efac30742f$var$n(), a = t.entries[t.entries.length - 1];
                if (i) {
                    var o = i.activationStart || 0, u = Math.max(0, i.responseStart - o);
                    e = {
                        timeToFirstByte: u,
                        firstByteToFCP: t.value - u,
                        loadState: $a3d672efac30742f$var$r(t.entries[0].startTime),
                        navigationEntry: i,
                        fcpEntry: a
                    };
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(i);
    }, e);
}, $a3d672efac30742f$var$I = 0, $a3d672efac30742f$var$x = 1 / 0, $a3d672efac30742f$var$k = 0, $a3d672efac30742f$var$A = function(t) {
    t.forEach(function(t) {
        t.interactionId && ($a3d672efac30742f$var$x = Math.min($a3d672efac30742f$var$x, t.interactionId), $a3d672efac30742f$var$k = Math.max($a3d672efac30742f$var$k, t.interactionId), $a3d672efac30742f$var$I = $a3d672efac30742f$var$k ? ($a3d672efac30742f$var$k - $a3d672efac30742f$var$x) / 7 + 1 : 0);
    });
}, $a3d672efac30742f$var$F = function() {
    "interactionCount" in performance || $a3d672efac30742f$var$t || ($a3d672efac30742f$var$t = $a3d672efac30742f$var$d("event", $a3d672efac30742f$var$A, {
        type: "event",
        buffered: !0,
        durationThreshold: 0
    }));
}, $a3d672efac30742f$var$P = [], $a3d672efac30742f$var$B = new Map, $a3d672efac30742f$var$O = 0, $a3d672efac30742f$var$R = function() {
    return ($a3d672efac30742f$var$t ? $a3d672efac30742f$var$I : performance.interactionCount || 0) - $a3d672efac30742f$var$O;
}, $a3d672efac30742f$var$j = [], $a3d672efac30742f$var$q = function(t) {
    if ($a3d672efac30742f$var$j.forEach(function(e) {
        return e(t);
    }), t.interactionId || "first-input" === t.entryType) {
        var e = $a3d672efac30742f$var$P[$a3d672efac30742f$var$P.length - 1], n = $a3d672efac30742f$var$B.get(t.interactionId);
        if (n || $a3d672efac30742f$var$P.length < 10 || t.duration > e.latency) {
            if (n) t.duration > n.latency ? (n.entries = [
                t
            ], n.latency = t.duration) : t.duration === n.latency && t.startTime === n.entries[0].startTime && n.entries.push(t);
            else {
                var r = {
                    id: t.interactionId,
                    latency: t.duration,
                    entries: [
                        t
                    ]
                };
                $a3d672efac30742f$var$B.set(r.id, r), $a3d672efac30742f$var$P.push(r);
            }
            $a3d672efac30742f$var$P.sort(function(t, e) {
                return e.latency - t.latency;
            }), $a3d672efac30742f$var$P.length > 10 && $a3d672efac30742f$var$P.splice(10).forEach(function(t) {
                return $a3d672efac30742f$var$B.delete(t.id);
            });
        }
    }
}, $a3d672efac30742f$var$H = function(t) {
    var e = self.requestIdleCallback || self.setTimeout, n = -1;
    return t = $a3d672efac30742f$var$v(t), "hidden" === document.visibilityState ? t() : (n = e(t), $a3d672efac30742f$var$p(t)), n;
}, $a3d672efac30742f$export$7f4cb060ded9173c = [
    200,
    500
], $a3d672efac30742f$var$W = function(t, e) {
    e = e || {}, $a3d672efac30742f$var$b(function() {
        var n;
        $a3d672efac30742f$var$F();
        var r, i = $a3d672efac30742f$var$f("INP"), a = function(t) {
            t.forEach($a3d672efac30742f$var$q);
            var e, n = (e = Math.min($a3d672efac30742f$var$P.length - 1, Math.floor($a3d672efac30742f$var$R() / 50)), $a3d672efac30742f$var$P[e]);
            n && n.latency !== i.value && (i.value = n.latency, i.entries = n.entries, r());
        }, o = $a3d672efac30742f$var$d("event", a, {
            durationThreshold: null !== (n = e.durationThreshold) && void 0 !== n ? n : 40
        });
        r = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$7f4cb060ded9173c, e.reportAllChanges), o && ("PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && o.observe({
            type: "first-input",
            buffered: !0
        }), $a3d672efac30742f$var$p(function() {
            a(o.takeRecords()), r(!0);
        }), $a3d672efac30742f$var$u(function() {
            $a3d672efac30742f$var$O = 0, $a3d672efac30742f$var$P.length = 0, $a3d672efac30742f$var$B.clear(), i = $a3d672efac30742f$var$f("INP"), r = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$7f4cb060ded9173c, e.reportAllChanges);
        }));
    });
}, $a3d672efac30742f$var$z = [], $a3d672efac30742f$var$U = new Map, $a3d672efac30742f$var$V = [], $a3d672efac30742f$var$_ = new WeakMap, $a3d672efac30742f$var$G = new Map, $a3d672efac30742f$var$J = -1, $a3d672efac30742f$var$K = function(t) {
    t.forEach(function(t) {
        return $a3d672efac30742f$var$z.push(t);
    });
}, $a3d672efac30742f$var$Q = function() {
    $a3d672efac30742f$var$G.size > 10 && $a3d672efac30742f$var$G.forEach(function(t, e) {
        $a3d672efac30742f$var$B.has(e) || $a3d672efac30742f$var$G.delete(e);
    }), $a3d672efac30742f$var$V = $a3d672efac30742f$var$V.slice(-50);
    var t = new Set($a3d672efac30742f$var$V.concat($a3d672efac30742f$var$P.map(function(t) {
        return $a3d672efac30742f$var$_.get(t.entries[0]);
    })));
    $a3d672efac30742f$var$U.forEach(function(e, n) {
        t.has(n) || $a3d672efac30742f$var$U.delete(n);
    });
    var e = new Set;
    $a3d672efac30742f$var$U.forEach(function(t) {
        $a3d672efac30742f$var$tt(t.startTime, t.processingEnd).forEach(function(t) {
            e.add(t);
        });
    }), $a3d672efac30742f$var$z = Array.from(e), $a3d672efac30742f$var$J = -1;
};
$a3d672efac30742f$var$j.push(function(t) {
    t.interactionId && t.target && !$a3d672efac30742f$var$G.has(t.interactionId) && $a3d672efac30742f$var$G.set(t.interactionId, t.target);
}, function(t) {
    for(var e, n = t.startTime + t.duration, r = $a3d672efac30742f$var$V.length - 1; r >= 0; r--)if (e = $a3d672efac30742f$var$V[r], Math.abs(n - e) <= 8) {
        var i = $a3d672efac30742f$var$U.get(e);
        i.startTime = Math.min(t.startTime, i.startTime), i.processingStart = Math.min(t.processingStart, i.processingStart), i.processingEnd = Math.max(t.processingEnd, i.processingEnd), i.entries.push(t), n = e;
        break;
    }
    n !== e && ($a3d672efac30742f$var$V.push(n), $a3d672efac30742f$var$U.set(n, {
        startTime: t.startTime,
        processingStart: t.processingStart,
        processingEnd: t.processingEnd,
        entries: [
            t
        ]
    })), (t.interactionId || "first-input" === t.entryType) && $a3d672efac30742f$var$_.set(t, n);
}, function() {
    $a3d672efac30742f$var$J < 0 && ($a3d672efac30742f$var$J = $a3d672efac30742f$var$H($a3d672efac30742f$var$Q));
});
var $a3d672efac30742f$var$X, $a3d672efac30742f$var$Y, $a3d672efac30742f$var$Z, $a3d672efac30742f$var$$, $a3d672efac30742f$var$tt = function(t, e) {
    for(var n, r = [], i = 0; n = $a3d672efac30742f$var$z[i]; i++)if (!(n.startTime + n.duration < t)) {
        if (n.startTime > e) break;
        r.push(n);
    }
    return r;
}, $a3d672efac30742f$export$7df4b36ecaed99e1 = function(t, n) {
    $a3d672efac30742f$var$e || ($a3d672efac30742f$var$e = $a3d672efac30742f$var$d("long-animation-frame", $a3d672efac30742f$var$K)), $a3d672efac30742f$var$W(function(e) {
        $a3d672efac30742f$var$H(function() {
            var n = function(t) {
                var e = t.entries[0], n = $a3d672efac30742f$var$_.get(e), i = $a3d672efac30742f$var$U.get(n), o = e.processingStart, c = i.processingEnd, u = i.entries.sort(function(t, e) {
                    return t.processingStart - e.processingStart;
                }), s = $a3d672efac30742f$var$tt(e.startTime, c), f = t.entries.find(function(t) {
                    return t.target;
                }), d = f && f.target || $a3d672efac30742f$var$G.get(e.interactionId), l = [
                    e.startTime + e.duration,
                    c
                ].concat(s.map(function(t) {
                    return t.startTime + t.duration;
                })), m = Math.max.apply(Math, l), p = {
                    interactionTarget: $a3d672efac30742f$var$a(d),
                    interactionTargetElement: d,
                    interactionType: e.name.startsWith("key") ? "keyboard" : "pointer",
                    interactionTime: e.startTime,
                    nextPaintTime: m,
                    processedEventEntries: u,
                    longAnimationFrameEntries: s,
                    inputDelay: o - e.startTime,
                    processingDuration: c - o,
                    presentationDelay: Math.max(m - c, 0),
                    loadState: $a3d672efac30742f$var$r(e.startTime)
                };
                return Object.assign(t, {
                    attribution: p
                });
            }(e);
            t(n);
        });
    }, n);
}, $a3d672efac30742f$export$948521ca5b0e1b17 = [
    2500,
    4e3
], $a3d672efac30742f$var$rt = {}, $a3d672efac30742f$export$947b1626ab8d5632 = function(t, e) {
    !function(t, e) {
        e = e || {}, $a3d672efac30742f$var$b(function() {
            var n, r = $a3d672efac30742f$var$S(), i = $a3d672efac30742f$var$f("LCP"), a = function(t) {
                e.reportAllChanges || (t = t.slice(-1)), t.forEach(function(t) {
                    t.startTime < r.firstHiddenTime && (i.value = Math.max(t.startTime - $a3d672efac30742f$var$s(), 0), i.entries = [
                        t
                    ], n());
                });
            }, o = $a3d672efac30742f$var$d("largest-contentful-paint", a);
            if (o) {
                n = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$948521ca5b0e1b17, e.reportAllChanges);
                var c = $a3d672efac30742f$var$v(function() {
                    $a3d672efac30742f$var$rt[i.id] || (a(o.takeRecords()), o.disconnect(), $a3d672efac30742f$var$rt[i.id] = !0, n(!0));
                });
                [
                    "keydown",
                    "click"
                ].forEach(function(t) {
                    addEventListener(t, function() {
                        return $a3d672efac30742f$var$H(c);
                    }, !0);
                }), $a3d672efac30742f$var$p(c), $a3d672efac30742f$var$u(function(r) {
                    i = $a3d672efac30742f$var$f("LCP"), n = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$948521ca5b0e1b17, e.reportAllChanges), $a3d672efac30742f$var$m(function() {
                        i.value = performance.now() - r.timeStamp, $a3d672efac30742f$var$rt[i.id] = !0, n(!0);
                    });
                });
            }
        });
    }(function(e) {
        var r = function(t) {
            var e = {
                timeToFirstByte: 0,
                resourceLoadDelay: 0,
                resourceLoadDuration: 0,
                elementRenderDelay: t.value
            };
            if (t.entries.length) {
                var r = $a3d672efac30742f$var$n();
                if (r) {
                    var i = r.activationStart || 0, o = t.entries[t.entries.length - 1], c = o.url && performance.getEntriesByType("resource").filter(function(t) {
                        return t.name === o.url;
                    })[0], u = Math.max(0, r.responseStart - i), s = Math.max(u, c ? (c.requestStart || c.startTime) - i : 0), f = Math.max(s, c ? c.responseEnd - i : 0), d = Math.max(f, o.startTime - i);
                    e = {
                        element: $a3d672efac30742f$var$a(o.element),
                        timeToFirstByte: u,
                        resourceLoadDelay: s - u,
                        resourceLoadDuration: f - s,
                        elementRenderDelay: d - f,
                        navigationEntry: r,
                        lcpEntry: o
                    }, o.url && (e.url = o.url), c && (e.lcpResourceEntry = c);
                }
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(r);
    }, e);
}, $a3d672efac30742f$export$65c59ea8064668fc = [
    800,
    1800
], $a3d672efac30742f$var$ot = function t(e) {
    document.prerendering ? $a3d672efac30742f$var$b(function() {
        return t(e);
    }) : "complete" !== document.readyState ? addEventListener("load", function() {
        return t(e);
    }, !0) : setTimeout(e, 0);
}, $a3d672efac30742f$var$ct = function(t, e) {
    e = e || {};
    var r = $a3d672efac30742f$var$f("TTFB"), i = $a3d672efac30742f$var$l(t, r, $a3d672efac30742f$export$65c59ea8064668fc, e.reportAllChanges);
    $a3d672efac30742f$var$ot(function() {
        var a = $a3d672efac30742f$var$n();
        a && (r.value = Math.max(a.responseStart - $a3d672efac30742f$var$s(), 0), r.entries = [
            a
        ], i(!0), $a3d672efac30742f$var$u(function() {
            r = $a3d672efac30742f$var$f("TTFB", 0), (i = $a3d672efac30742f$var$l(t, r, $a3d672efac30742f$export$65c59ea8064668fc, e.reportAllChanges))(!0);
        }));
    });
}, $a3d672efac30742f$export$33a01e6c5f2c7e33 = function(t, e) {
    $a3d672efac30742f$var$ct(function(e) {
        var n = function(t) {
            var e = {
                waitingDuration: 0,
                cacheDuration: 0,
                dnsDuration: 0,
                connectionDuration: 0,
                requestDuration: 0
            };
            if (t.entries.length) {
                var n = t.entries[0], r = n.activationStart || 0, i = Math.max((n.workerStart || n.fetchStart) - r, 0), a = Math.max(n.domainLookupStart - r, 0), o = Math.max(n.connectStart - r, 0), c = Math.max(n.connectEnd - r, 0);
                e = {
                    waitingDuration: i,
                    cacheDuration: a - i,
                    dnsDuration: o - a,
                    connectionDuration: c - o,
                    requestDuration: t.value - c,
                    navigationEntry: n
                };
            }
            return Object.assign(t, {
                attribution: e
            });
        }(e);
        t(n);
    }, e);
}, $a3d672efac30742f$var$st = {
    passive: !0,
    capture: !0
}, $a3d672efac30742f$var$ft = new Date, $a3d672efac30742f$var$dt = function(t, e) {
    $a3d672efac30742f$var$X || ($a3d672efac30742f$var$X = e, $a3d672efac30742f$var$Y = t, $a3d672efac30742f$var$Z = new Date, $a3d672efac30742f$var$pt(removeEventListener), $a3d672efac30742f$var$lt());
}, $a3d672efac30742f$var$lt = function() {
    if ($a3d672efac30742f$var$Y >= 0 && $a3d672efac30742f$var$Y < $a3d672efac30742f$var$Z - $a3d672efac30742f$var$ft) {
        var t = {
            entryType: "first-input",
            name: $a3d672efac30742f$var$X.type,
            target: $a3d672efac30742f$var$X.target,
            cancelable: $a3d672efac30742f$var$X.cancelable,
            startTime: $a3d672efac30742f$var$X.timeStamp,
            processingStart: $a3d672efac30742f$var$X.timeStamp + $a3d672efac30742f$var$Y
        };
        $a3d672efac30742f$var$$.forEach(function(e) {
            e(t);
        }), $a3d672efac30742f$var$$ = [];
    }
}, $a3d672efac30742f$var$mt = function(t) {
    if (t.cancelable) {
        var e = (t.timeStamp > 1e12 ? new Date : performance.now()) - t.timeStamp;
        "pointerdown" == t.type ? function(t, e) {
            var n = function() {
                $a3d672efac30742f$var$dt(t, e), i();
            }, r = function() {
                i();
            }, i = function() {
                removeEventListener("pointerup", n, $a3d672efac30742f$var$st), removeEventListener("pointercancel", r, $a3d672efac30742f$var$st);
            };
            addEventListener("pointerup", n, $a3d672efac30742f$var$st), addEventListener("pointercancel", r, $a3d672efac30742f$var$st);
        }(e, t) : $a3d672efac30742f$var$dt(e, t);
    }
}, $a3d672efac30742f$var$pt = function(t) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(e) {
        return t(e, $a3d672efac30742f$var$mt, $a3d672efac30742f$var$st);
    });
}, $a3d672efac30742f$export$8f7f3c48ca6fbe34 = [
    100,
    300
], $a3d672efac30742f$var$gt = function(t, e) {
    e = e || {}, $a3d672efac30742f$var$b(function() {
        var n, r = $a3d672efac30742f$var$S(), i = $a3d672efac30742f$var$f("FID"), a = function(t) {
            t.startTime < r.firstHiddenTime && (i.value = t.processingStart - t.startTime, i.entries.push(t), n(!0));
        }, o = function(t) {
            t.forEach(a);
        }, c = $a3d672efac30742f$var$d("first-input", o);
        n = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$8f7f3c48ca6fbe34, e.reportAllChanges), c && ($a3d672efac30742f$var$p($a3d672efac30742f$var$v(function() {
            o(c.takeRecords()), c.disconnect();
        })), $a3d672efac30742f$var$u(function() {
            var r;
            i = $a3d672efac30742f$var$f("FID"), n = $a3d672efac30742f$var$l(t, i, $a3d672efac30742f$export$8f7f3c48ca6fbe34, e.reportAllChanges), $a3d672efac30742f$var$$ = [], $a3d672efac30742f$var$Y = -1, $a3d672efac30742f$var$X = null, $a3d672efac30742f$var$pt(addEventListener), r = a, $a3d672efac30742f$var$$.push(r), $a3d672efac30742f$var$lt();
        }));
    });
}, $a3d672efac30742f$export$39705a25c49af873 = function(t, e) {
    $a3d672efac30742f$var$gt(function(e) {
        var n = function(t) {
            var e = t.entries[0], n = {
                eventTarget: $a3d672efac30742f$var$a(e.target),
                eventType: e.name,
                eventTime: e.startTime,
                eventEntry: e,
                loadState: $a3d672efac30742f$var$r(e.startTime)
            };
            return Object.assign(t, {
                attribution: n
            });
        }(e);
        t(n);
    }, e);
};





/**
 * Log a Web Vital to Google Analytics.
 * @param {ReportedMetric} metric - A {@link https://github.com/GoogleChrome/web-vitals} metric.
 * @see https://web.dev/vitals-field-measurement-best-practices/
 */ function $de30180945983a2a$var$log(metric) {
    const { name: name, delta: delta, value: value, id: id, attribution: attribution } = metric;
    const eventParams = {
        event_category: "Web Vitals",
        // Use a non-interaction event to avoid affecting bounce rate
        non_interaction: true,
        // Built-in params:
        value: delta,
        // Custom params:
        metric_id: id,
        metric_value: value,
        metric_delta: delta
    };
    switch(name){
        case "CLS":
            eventParams.debug_target = attribution.largestShiftTarget;
            break;
        case "FID":
            eventParams.debug_target = attribution.eventTarget;
            break;
        case "INP":
            eventParams.debug_target = attribution.interactionTarget;
            break;
        case "LCP":
            eventParams.debug_target = attribution.element;
            break;
    }
    $6c5e0b5e87abddb0$export$5e9eec8001665ac5(name, eventParams);
}
function $de30180945983a2a$export$6f33aa561ac6dad() {
    [
        (0, $a3d672efac30742f$export$a7873055838e5ad8),
        (0, $a3d672efac30742f$export$39705a25c49af873),
        (0, $a3d672efac30742f$export$7df4b36ecaed99e1),
        (0, $a3d672efac30742f$export$947b1626ab8d5632)
    ].forEach((onVital)=>{
        onVital($de30180945983a2a$var$log);
    });
}


if (null) null.accept();
$de30180945983a2a$export$6f33aa561ac6dad();
$7f17118e49d273d4$export$b61bda4fbca264f2();

document.addEventListener("DOMContentLoaded", async ()=>{
    // @ts-expect-error Elm module
    const { Elm: Elm } = await (parcelRequire("7x21c"));
    const elm = Elm.Main.init({
        node: document.getElementById($g5hEw.elmRootId),
        flags: {
            deviceInfo: $2d6202cc1958cad9$export$c73dcf559dad2f44(),
            storedState: $1c2cb310b7d342e3$export$50fdfeece43146fd()
        }
    });
    $2d6202cc1958cad9$export$1e04eab7cef66ad5(elm.ports.deviceInfoChanged.send);
    if ($1c2cb310b7d342e3$export$d2f44a0250447fe3("localStorage")) {
        elm.ports.storeState.subscribe($1c2cb310b7d342e3$export$42fffed799c298bb);
        $1c2cb310b7d342e3$export$219681ab961e5694(elm.ports.storedStateChanged.send);
    }
    elm.ports.consoleError.subscribe((args)=>{
        console.error(...args);
    });
    elm.ports.checkValidity.subscribe((id)=>{
        $7f17118e49d273d4$export$50d70f8cedc54453(id).then((validity)=>{
            elm.ports.checkValidityResult.send({
                id: id,
                success: true,
                validity: validity
            });
        }).catch((error)=>{
            elm.ports.checkValidityResult.send({
                id: id,
                success: false,
                error: error
            });
        });
    });
    elm.ports.callSendContactFormEmail.subscribe((email)=>{
        $c0309db34c5713de$export$5e26890bf91986b4(email).then(()=>{
            elm.ports.callSendContactFormEmailResult.send({
                success: true
            });
        }).catch((error)=>{
            elm.ports.callSendContactFormEmailResult.send({
                success: false,
                error: error
            });
        });
    });
});


//# sourceMappingURL=index.81df1607.js.map
